import { useEffect, useState } from "react";
import useLocalStorage from "./useLocalStorage";

export const PREFIX = "[exp] ";

export type Variants = (string | boolean)[];

function checkIfLocalStorageSupported() {
  try {
    localStorage.setItem("testItem", "1");
    localStorage.removeItem("testItem");
    return true;
  } catch (error) {
    return false;
  }
}

const hasLocalStorage = checkIfLocalStorageSupported();

export function getVariantsFromPercent(percentage: number) {
  if (typeof percentage !== "number" || percentage <= 0 || percentage > 100) {
    return [];
  }
  const variants = Array.from({ length: 100 }, (_, i) => i < percentage);
  return variants;
}

export default function useExperiment(
  experimentName: string,
  variants: Variants
) {
  const [isInExperiment, setExperimentValue] = useState<
    string | boolean | Object
  >(null);

  const controlVariant = variants[0];
  const randomVariant = variants[Math.floor(Math.random() * variants.length)];
  const [variantValue] = useLocalStorage(
    PREFIX + experimentName,
    randomVariant
  );

  useEffect(() => {
    if (variantValue !== null) {
      setExperimentValue(variantValue);
      // trackCustomEvent({
      //   action: experimentName,
      //   category: "Experiment",
      //   label: hasLocalStorage ? variantValue : controlVariant,
      //   nonInteraction: true,
      // });
    }
  }, [controlVariant, experimentName, variantValue]);

  // very rare case where the user has no localstorage
  if (!hasLocalStorage) {
    return controlVariant;
  }

  return isInExperiment;
}
